import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../api";
import moment from "moment";
import ViewEditVoucher from "./ViewEditVoucher";
import Swal from "sweetalert2";
import Pagination from "../Homepage/Pagination";
import { useLocation } from "react-router-dom";
import CloseForm from "../Master/CloseForm";
import { toast } from "react-toastify";
import html2pdf from "html2pdf.js";
import JSZip from "jszip";
import { saveAs } from "file-saver";

function Vouchers() {
  const params = new URLSearchParams(useLocation().search);
  const [vouchers, setVouchers] = useState([]);
  const [loading, setloading] = useState(false);
  const [isEdit, setisEdit] = useState([]);
  const [voucherId, setVoucherId] = useState(0);
  const [showVoucher, setShowVoucher] = useState(false);
  const [refresh, setrefresh] = useState(false);
  const [page, setpage] = useState(1);
  const [search, setSearch] = useState(params.get("search") ?? "");
  const [isEnter, setIsEnter] = useState(false);
  const [pagecount, setpagecount] = useState(0);
  const [total, setTotal] = useState(0);
  const voucherStatus = ["Pending", "Approved", "Rejected"];
  const [index, setIndex] = useState(0);
  const [showReason, setShowReason] = useState(false);
  const [showReasonLoading, setShowReasonLoading] = useState([]);

  useEffect(() => {
    setloading(true);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/Voucher/GetAllVouchers?search=${search}&page=${page}`
      )
      .then((res) => {
        setVouchers(res.data?.data);
        setisEdit(Array.from({ length: res.data?.data?.length }, () => false));
        setShowReasonLoading(
          Array.from({ length: res.data?.data?.length }, () => false)
        );
        setpagecount(res.data?.pages);
        setTotal(res.data?.count);
      })
      .catch(console.log)
      .finally(() => {
        setloading(false);
      });
  }, [refresh, isEnter, page]);

  const generateHTML = (data) => {
    const vouchers = data.vouchers ?? [];

    const totalAmount = vouchers.reduce(
      (sum, v) => sum + (v.amount ?? 0.0),
      0.0
    );

    return `
  <html>
    <body style="padding: 20px; margin: 0; box-sizing: border-box; font-family: sans-serif; min-height: 100vh; width:100%; display:flex; flex-direction: column;">

      <!-- HEADER -->
      <div style="text-align:center;">
        <h2>ROSS BOILERS</h2>
        <p>No.33, Burhani Industrial Estate, Kondhwa (Bk), Pune - 411048</p>
        <h3>DEBIT VOUCHER</h3>
      </div>

      <br/>

      <!-- DETAILS -->
      <div width="100%" style="display: grid; grid-template-columns: 1fr 1fr; column-gap: 1rem;">
       
          <span><strong>Pay To:</strong> ${data.userId || "-"}</span>
        
          <span><strong>Account Of:</strong> ${
            data.ticket?.customer?.orgName || "-"
          }</span>
          <span><strong>Voucher No:</strong> ${data.voucherNumber || "-"}</span>
        
          <span><strong>Date:</strong> ${moment(
            new Date(data?.updatedDate ?? data?.createdDate)
          ).format("DD/MM/YYYY")}</span>
          <span><strong>Ticket ID:</strong> ${
            data.ticket?.seriesId || "-"
          }</span>
          <span><strong>Voucher Status:</strong> ${
            voucherStatus[data?.voucherStatus]
          }</span>
          <span><strong>${
            data?.voucherStatus == 2 ? "Reject Reason: " : ""
          }</strong> ${
      data?.voucherStatus == 2 ? data?.rejectReason : ""
    }</span>
      </div>

      <!-- PARTICULARS TITLE -->
      <h3>PARTICULARS</h3>

      <!-- TABLE -->
      <table border="1" cellspacing="0" cellpadding="6" width="100%" style="border-collapse: collapse; text-align:center;">
        <thead>
          <tr>       
            <th width="15%">Date</th>
            <th width="30%">Description</th>
            <th width="25%">Remark</th>
            <th width="15%">Distance Travelled</th>
            <th width="15%">Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          ${vouchers
            .map(
              (v) => `
            <tr>
              <td width="15%">${
                v.voucherDate ? moment(v.voucherDate).format("DD/MM/YYYY") : "-"
              }</td>
              <td width="30%" style="text-align:left;">${
                v.description || "-"
              }</td>
              <td width="25%" style="text-align:left;">${v.remarks || "-"}</td>
              <td width="15%">${v?.distanceTravelled ?? "-"}</td>
              <td width="15%">${parseFloat(v.amount).toFixed(2)}</td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>

      <br/>

      <!-- TOTALS -->
      <table width="100%">
        
        <tr>
          <td style="text-align:right;"><b>Grand Total</b></td>
          <td style="text-align:right;">₹ ${parseFloat(totalAmount).toFixed(
            2
          )}</td>
        </tr>
      </table>

      <br/><br/><br/>

      <!-- SIGNATURES -->
      <table width="100%" style="margin-top: auto;">
        <tr>
          <td>Receiver’s Sign</td>
          <td style="text-align:center;">Verified By</td>
          <td style="text-align:right;">Authorized By</td>
        </tr>
      </table>

    </body>
  </html>
  `;
  };

  async function downloadFiles(files) {
    const response = await Promise.all(
      files.map((fileName) =>
        fetch(`${process.env.REACT_APP_API_URL}/voucherFiles/${fileName}`)
      )
    );

    response.forEach(async (res, i) => {
      const blob = await res.blob();
      saveAs(blob, files[i]);
    });
  }

  return (
    <section className="technician-vouchers">
      <h1>Vouchers</h1>
      {showVoucher && (
        <ViewEditVoucher
          setShowVoucher={setShowVoucher}
          voucherId={voucherId}
          setrefresh={setrefresh}
          refresh={refresh}
        />
      )}
      <input
        type="search"
        placeholder="Enter Search Keyword"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setIsEnter(!isEnter);
            setpage(1);
          }
        }}
      />
      <p>
        <strong>Total: </strong>
        {total}
      </p>
      <section className="table">
        <section>
          <div>
            <aside style={{ gridTemplateColumns: "repeat(7, 1fr)" }}>
              <blockquote style={{ width: "20rem" }}>Username</blockquote>
              <blockquote style={{ width: "20rem" }}>Ticket Id</blockquote>
              <blockquote style={{ width: "20rem" }}>Voucher Number</blockquote>
              <blockquote style={{ width: "20rem" }}>Status</blockquote>
              <blockquote style={{ gridColumn: "span 3" }}>Actions</blockquote>
            </aside>
          </div>
          <div>
            {vouchers.length > 0 ? (
              <>
                {vouchers.map((x, i) => (
                  <aside style={{ gridTemplateColumns: "repeat(7, 1fr)" }}>
                    <blockquote style={{ width: "20rem" }}>
                      {x.userId}
                    </blockquote>
                    <blockquote style={{ width: "20rem" }}>
                      {x.ticket?.seriesId}
                    </blockquote>

                    <blockquote style={{ width: "20rem" }}>
                      {x.voucherNumber}
                    </blockquote>
                    <blockquote
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "20rem",
                      }}
                    >
                      {isEdit[i] ? (
                        <select
                          onChange={(e) => {
                            if (e.target.value == "2") {
                              setIndex(i);
                              setShowReason(true);
                              setVouchers((prev) =>
                                prev.map((y, j) =>
                                  j === i
                                    ? {
                                        ...y,
                                        rejectReason: "",
                                      }
                                    : y
                                )
                              );
                            }
                            setVouchers((prev) =>
                              prev.map((y, j) =>
                                j === i
                                  ? {
                                      ...y,
                                      voucherStatus: e.target.value,
                                    }
                                  : y
                              )
                            );
                          }}
                        >
                          <option value="" selected={x?.voucherStatus == ""}>
                            Select Status
                          </option>

                          <option value="1" selected={x?.voucherStatus == "1"}>
                            Approved
                          </option>
                          <option value="2" selected={x?.voucherStatus == "2"}>
                            Rejected
                          </option>
                        </select>
                      ) : (
                        <span>{voucherStatus[x.voucherStatus]}</span>
                      )}
                      {isEdit[i] ? (
                        <>
                          <i
                            className="fa-solid fa-xmark"
                            onClick={() => {
                              setisEdit((prev) => prev.map((_) => false));
                            }}
                          ></i>
                          {showReasonLoading[i] ? (
                            <i className="fa-solid fa-spinner fa-2x fa-spin"></i>
                          ) : (
                            <i
                              className="fa-solid fa-floppy-disk"
                              onClick={() => {
                                setShowReasonLoading((prev) =>
                                  prev.map((_, j) => j === i)
                                );
                                const formData = new FormData();
                                formData.append(
                                  "VoucherNumber",
                                  x?.voucherNumber
                                );
                                formData.append("TicketId", x?.ticketId);
                                formData.append(
                                  "VoucherStatus",
                                  x?.voucherStatus
                                );
                                formData.append(
                                  "RejectReason",
                                  x?.rejectReason
                                );
                                axiosInstance
                                  .put(
                                    `${process.env.REACT_APP_API_URL}/api/Voucher/UpdateVouchers`,
                                    formData
                                  )
                                  .then((res) => {
                                    setrefresh(!refresh);
                                  })
                                  .catch(console.log)
                                  .finally(() => {
                                    setShowReasonLoading((prev) =>
                                      prev.map((_) => false)
                                    );
                                  });
                              }}
                            ></i>
                          )}
                        </>
                      ) : (
                        <i
                          className="fa-solid fa-pen-to-square"
                          onClick={() => {
                            setisEdit((prev) => prev.map((y, j) => j === i));
                          }}
                        ></i>
                      )}
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        axiosInstance
                          .get(
                            `${process.env.REACT_APP_API_URL}/api/Voucher/GetSingleVoucher/${x?.voucherNumber}`
                          )
                          .then((res) => {
                            const html = generateHTML(res?.data);
                            const element = document.createElement("div");
                            element.innerHTML = html;

                            const options = {
                              margin: 0.5,
                              filename: `voucherReport${Date.now()}.pdf`,
                              image: { type: "jpeg", quality: 1 },
                              html2canvas: { scale: 2 },
                              jsPDF: {
                                unit: "in",
                                format: "a4",
                                orientation: "portrait",
                              },
                            };

                            html2pdf().set(options).from(element).save();
                          })
                          .catch(console.log);
                      }}
                    >
                      <i class="fa-solid fa-file-pdf" />
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        axiosInstance
                          .get(
                            `${process.env.REACT_APP_API_URL}/api/Voucher/GetSingleVoucher/${x?.voucherNumber}`
                          )
                          .then(async (res) => {
                            const files = res.data?.vouchers?.map(
                              (x) => x?.fileNames
                            );
                            const fileNames = files
                              ?.flatMap((x) => x?.split(","))
                              ?.filter((x) => x != "");
                            if (fileNames?.length > 0) {
                              await downloadFiles(fileNames);
                            } else {
                              toast.error("No files to download", {
                                position: "bottom-center",
                                theme: "dark",
                              });
                            }
                          })
                          .catch(console.log);
                      }}
                    >
                      <i class="fa-solid fa-download" />
                    </blockquote>
                    {/*<blockquote
                      onClick={() => {
                        setVoucherId(x?.voucherNumber);
                        setShowVoucher(true);
                      }}
                    >
                      <i className="fa-solid fa-eye"></i>
                    </blockquote>
                    <blockquote
                      onClick={() => {
                        setisEdit(true);
                        setVoucherId(x.id);
                        setShowVoucher(true);
                      }}
                    >
                      <i className="fa-solid fa-pen-to-square"></i>
                    </blockquote>*/}
                    <blockquote
                      onClick={() => {
                        Swal.fire({
                          title: "Delete Voucher",
                          text: "Are you sure you want to delete voucher?",
                          showCancelButton: true,
                          showConfirmButton: true,
                          icon: "error",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            axiosInstance
                              .delete(
                                `${process.env.REACT_APP_API_URL}/api/Voucher/DeleteVoucher/${x?.voucherNumber}`
                              )
                              .then((res) => {
                                setrefresh(!refresh);
                              })
                              .catch(console.log);
                          }
                        });
                      }}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </blockquote>
                  </aside>
                ))}
                {loading && (
                  <aside style={{ gridTemplateColumns: "repeat(11, 1fr)" }}>
                    <blockquote style={{ gridColumn: "span 11" }}>
                      <center>
                        <i className="fa-solid fa-spinner fa-3x fa-spin"></i>
                      </center>
                    </blockquote>
                  </aside>
                )}
              </>
            ) : (
              <aside style={{ gridTemplateColumns: "repeat(11, 1fr)" }}>
                <blockquote style={{ gridColumn: "span 11" }}>
                  No Records Found
                </blockquote>
              </aside>
            )}
          </div>
        </section>
      </section>
      {showReason && (
        <div className="reject-reason-vouchers">
          <blockquote>
            <label>Enter Reject Reason</label>
            <textarea
              rows={5}
              placeholder="Enter Reject Reason (Maximum 400 Characters)"
              value={vouchers[index]?.rejectReason}
              onChange={(e) => {
                setVouchers((prev) =>
                  prev.map((x, j) =>
                    j === index
                      ? {
                          ...x,
                          rejectReason: e.target.value.slice(0, 400),
                        }
                      : x
                  )
                );
              }}
            />
            <i
              className="fa-solid fa-xmark fa-2x"
              onClick={() => {
                setShowReason(false);
                setVouchers((prev) =>
                  prev.map((y, j) =>
                    j === index
                      ? {
                          ...y,
                          voucherStatus: "1",
                          rejectReason: "",
                        }
                      : y
                  )
                );
              }}
            ></i>
            <button
              onClick={() => {
                if (vouchers[index]?.rejectReason) {
                  setShowReason(false);
                } else {
                  toast.error("Please Enter Reason", {
                    position: "bottom-center",
                    theme: "dark",
                  });
                }
              }}
            >
              Ok
            </button>
          </blockquote>
        </div>
      )}
      <Pagination count={pagecount} setpagenumber={setpage} pagenumber={page} />
    </section>
  );
}

export default Vouchers;
